/**
 * Context de Sessão
 */

import React, { createContext, useContext, useState, useCallback } from 'react';
import { SessionUtil } from '@utils';
import { ClienteSession } from '@types';

interface SessionContextData {
  cliente: ClienteSession | null;
  lastClassificacao: string | null;
  setCliente: (codigo: string, nome: string) => void;
  clearCliente: () => void;
  setLastClassificacao: (codigo: string) => void;
  clearNavigation: () => void;
}

const SessionContext = createContext<SessionContextData | undefined>(undefined);

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [cliente, setClienteState] = useState<ClienteSession | null>(() =>
    SessionUtil.getCliente()
  );
  const [lastClassificacao, setLastClassificacaoState] = useState<string | null>(() =>
    SessionUtil.getLastClassificacao()
  );

  const setCliente = useCallback((codigo: string, nome: string) => {
    SessionUtil.setCliente(codigo, nome);
    setClienteState({ cliCodigo: codigo, cliNome: nome });
  }, []);

  const clearCliente = useCallback(() => {
    SessionUtil.clearCliente();
    setClienteState(null);
  }, []);

  const setLastClassificacao = useCallback((codigo: string) => {
    SessionUtil.setLastClassificacao(codigo);
    setLastClassificacaoState(codigo);
  }, []);

  const clearNavigation = useCallback(() => {
    SessionUtil.clearNavigation();
    setLastClassificacaoState(null);
  }, []);

  return (
    <SessionContext.Provider
      value={{
        cliente,
        lastClassificacao,
        setCliente,
        clearCliente,
        setLastClassificacao,
        clearNavigation,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSessionContext = () => {
  const context = useContext(SessionContext);

  if (!context) {
    throw new Error('useSessionContext must be used within SessionProvider');
  }

  return context;
};